import ContentGroup from './ContentGroup';

export default ContentGroup;
export { ContentGroup };
